export const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export const addDays = (d, n) => {
  const x = new Date(d);
  x.setDate(x.getDate() + n);
  return x;
};

export const weekendWindow = (now = new Date()) => {
  const day = now.getDay();
  const start = day === 0 || day >= 5 ? now : addDays(now, 5 - day);
  const end = addDays(start, day === 0 ? 0 : 6 - start.getDay() + 1);
  return { from: iso(start), to: iso(end) };
};
